import { render, staticRenderFns } from "./SafetyAccidentBasicData.vue?vue&type=template&id=6523aa90&scoped=true&"
import script from "./SafetyAccidentBasicData.vue?vue&type=script&lang=js&"
export * from "./SafetyAccidentBasicData.vue?vue&type=script&lang=js&"
import style0 from "./SafetyAccidentBasicData.vue?vue&type=style&index=0&id=6523aa90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6523aa90",
  null
  
)

export default component.exports